<template>
<div class="view">

	<box>			  
		<table class="table-a">
			<tr>
				<th></th>
				<th>Projekt</th>
				<th>Kunde</th>
				<th>Betalingsmodel</th>
				<th class="align-r">Til betaling</th>
				<th>Fakturering</th>
				<th>Aktiv</th>
			</tr>
			<tr v-for="(project,i) in projects_money_owed" :key="'asd'+i">
				<td><avatar :input="project" /></td>
				<td><router-link class="textlink" :to="'/project/'+project.key">{{ project.name }}</router-link></td>
				<td><router-link class="textlink" :to="'/client/'+project.client.key">{{ project.client.name }}</router-link></td>
				<td>{{ project.payment_model | tr_payment_model }}</td>
				<td class="align-r">{{ project.payable_remaining | money(0) }} kr.</td>
				<td>{{ project.invoice_ready | boolstr(['Klar','Ikke klar']) }}</td>
				<td>{{ project.status | tr_project_status }}</td>
			</tr>			
		</table>		  
	</box>	
	

</div>
</template>

<script>
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
export default {
	mixins: [ mixins.db, mixins.generic ],
	components: { Box, Btn, Avatar },
	data: function () { return {


	}},
	computed:{

		projects_money_owed(){
			
			var projects = this.getAll('projects')
			//projects = projects.filter((e)=>e.status!='draft')			

			var output = []
			for( let project of projects ) {
				project.client = this.$store.getters['clients/getOne'](project.client_key) || {name:'Ukendt'}
				//if( !payable_amount ) continue
				project.payable_amount = this.$store.getters['projects/get_payable_amount'](project)
				project.invoiced_and_paid = this.$store.getters['projects/get_invoiced_and_paid_dkk'](project)
				project.payable_remaining = project.payable_amount - project.invoiced_and_paid

				project.invoice_ready = ( (project.tags||'').toLowerCase().indexOf('fakturaklar') !== -1 )
				output.push(project)
			}
			
			//output = output.filter((e)=>!e.invoice_ready)

			output = output.sort((a,b)=>{ return b.payable_remaining - a.payable_remaining })

			return output
		},

	},
	methods: {	

	},
}
</script>



// WEBPACK FOOTER //
// ReportMissingPayments.vue?2abc3893